import { render } from "./PatchTab.vue?vue&type=template&id=325d1de5"
import script from "./PatchTab.vue?vue&type=script&lang=js"
export * from "./PatchTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__